import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { logger } from 'app/core/util/logger';
import { getEnvironment } from 'app/appSettings';
import { util } from '../util/util';

@Injectable({ providedIn: 'root' })
export class ComesFromLaunchpadGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean  | UrlTree {
    logger.debug(`In ComesFromLaunchpadGuard`);

    const environment = getEnvironment();
    const launchpadCookie = util.getCookie('launchpad');

    if (!launchpadCookie) {
      if (environment.includes('localhost')) {
        // window.location.href = 'http://localhost:4300/';
        return true;
      }

      switch (environment.toLocaleLowerCase()) {
        case 'dev':
          document.location.href = 'https://mydev.europoolsystem.com';
          return false;
        case 'qas':
          document.location.href = 'https://myacc.europoolsystem.com';
          return false;
        default:
          document.location.href = 'https://my.europoolsystem.com';
          return false;
      }
    }

    return true;
  }
}
